<!-- <div class="footer">
  <p jhiTranslate="footer">This is your footer</p>
</div> -->

<div class="container-fluid p-0 main-footer">
  <div class="row">
    <div class="col-md-12" >
      <p class="footer-text">Copyright 2025 Bhumaha Solutions private Limited</p>
    </div>
  </div>
</div>
